export class EmergencyAccessPasswordRequest {
    newMasterPasswordHash: string;
    key: string;
}
